import React from 'react';
import Header from 'modules/common/components/Header';
import Footer from 'modules/common/components/Footer';
import SEO from 'modules/App/components/SEO';

type HeaderLayoutProps = React.ComponentProps<typeof SEO>;

export default function HeaderLayout({ children, ...props }: HeaderLayoutProps) {

  return (
    <>
      <SEO {...props} />
      <Header />
      <main>{children}</main>

      <Footer />
    </>
  );
}
